import { render } from "./TeacherColumnsSelect.vue?vue&type=template&id=583f9300&scoped=true&ts=true"
import script from "./TeacherColumnsSelect.vue?vue&type=script&lang=ts"
export * from "./TeacherColumnsSelect.vue?vue&type=script&lang=ts"

import "./TeacherColumnsSelect.vue?vue&type=style&index=0&id=583f9300&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583f9300"]])

export default __exports__